import * as types from './actionTypes';

export function changeHomeSectionAction (homeSection) {
    return {type: types.CHANGE_HOMESECTION, homeSection}
}